import { makeStyles } from "@mui/styles"
import { colors } from "../../utils"

const useStyles = makeStyles((theme) => ({
  footerContainer: {
    width: "100%",
    backgroundColor: colors.greyStrong,
    alignItems: "center",
    color: colors.white,
    display: "flex",
    justifyContent: "space-around",
    fontSize: "1rem",
    [theme.breakpoints.up("sm")]: {
      justifyContent: "space-between",
    },
  },

  footerText: {
    [theme.breakpoints.up("sm")]: {
      margin: "0 10px",
    },
  },

  footerIcons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    [theme.breakpoints.up("sm")]: {
      margin: "0 10px",
    },
  },
  icons: {
    visibility: "hidden",
    "&.MuiButtonBase-root": {
      color: colors.white,
    },
  },
}))

export default useStyles
